export var debugModes;
(function (debugModes) {
    debugModes["geolocation"] = "geo";
})(debugModes || (debugModes = {}));
class ConsoleDebug {
    constructor() {
        this.debugModes = this.get();
        if (this.debugModes.length > 0) {
            if (this.debugModes.length > 1) {
                console.info(`%cDebug modes: ${this.debugModes.join(',')} enabled`, 'font-weight: bold; color: green;');
            }
            else {
                console.info(`%cDebug mode: ${this.debugModes} enabled`, 'font-weight: bold; color: green;');
            }
        }
    }
    listOptions() {
        console.info(Object.values(debugModes)
            .map((value) => `- ${value}`)
            .join('\n'));
    }
    listEnabled() {
        this.debugModes = this.get();
        console.info(this.debugModes.map((value) => `- ${value}`).join('\n'));
    }
    isEnabled(code) {
        return this.contains(code.toString());
    }
    get() {
        const debugModesString = localStorage.getItem('debug_console');
        this.debugModes = [];
        if (debugModesString) {
            this.debugModes = JSON.parse(debugModesString);
        }
        return this.debugModes;
    }
    enable(debugMode) {
        this.debugModes = this.get();
        if (typeof debugMode === 'string') {
            this.debugModes = [...this.debugModes, debugMode];
            console.info(`%cDebug mode: ${debugMode} enabled`, 'font-weight: bold; color: green;');
        }
        else {
            this.debugModes = [...this.debugModes, ...debugMode];
            console.info(`%cDebug modes: ${debugMode.join(',')} enabled`, 'font-weight: bold; color: green;');
        }
        localStorage.setItem('debug_console', JSON.stringify(this.debugModes));
    }
    disable(debugMode) {
        if (typeof debugMode === 'string') {
            this.debugModes = this.debugModes.filter((item) => {
                return item !== debugMode;
            });
            console.info(`%cDebug mode: ${debugMode} disabled`, 'color: #FC0000;');
        }
        else {
            this.debugModes = this.debugModes.filter((item) => {
                return !debugMode.includes(item);
            });
            console.info(`%cDebug modes: ${debugMode.join(',')}  disabled`, 'color: #FC0000;');
        }
        localStorage.setItem('debug_console', JSON.stringify(this.debugModes));
    }
    contains(debugMode) {
        const debugModes = this.get();
        if (debugModes.includes(debugMode)) {
            return true;
        }
        return false;
    }
}
const debugInit = () => {
    window.thDebug = new ConsoleDebug();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debugLog = (debugMode = 'general', args, type = 'info') => {
    var _a;
    if ((_a = window.thDebug) === null || _a === void 0 ? void 0 : _a.contains(debugMode)) {
        switch (type) {
            case 'error':
                console.error(...args);
                break;
            default:
                console.info(`%c${debugMode}:`, 'font-weight: bold; color: orange;', ...args);
                break;
        }
    }
};
debugInit();
export default ConsoleDebug;
